var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 71,
    viewBox: "0 0 261 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.10063 8.20727C3.68892 3.79513 7.45255 0.5 11.9037 0.5H248.83C253.281 0.5 257.045 3.79513 257.633 8.20727L258.387 13.8579C260.273 28.0092 260.273 42.3484 258.387 56.4997L257.633 62.1503C257.045 66.5625 253.281 69.8576 248.83 69.8576H11.9037C7.45256 69.8576 3.68892 66.5625 3.10063 62.1504L2.34723 56.4998C0.460375 42.3484 0.460374 28.0092 2.34722 13.8578L3.10063 8.20727Z",
    stroke: "",
    strokeOpacity: ""
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnBg);
export default __webpack_public_path__ + "static/media/btn-bg.0afb8f8f.svg";
export { ForwardRef as ReactComponent };